import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { getCountriesByPage } from '../../ApiServices/CountriesService';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  message: null
};

const countrySlice = createSlice({
  name: 'countries',
  initialState: initialState,
  reducers: {
    clearCountryState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchCountries.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
    });
    builder.addCase(fetchCountries.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.error = action?.payload?.data;
    });
  }
});

export const countryState = (state: RootState) => state?.country;
export const { clearCountryState } = countrySlice.actions;
export default countrySlice.reducer;

export const fetchCountries = createAsyncThunk(
  'country/fetchCountries',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_COUNTRIES') }));
      return fulfillWithValue(await getCountriesByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
